import { render, staticRenderFns } from "./BookMatch.vue?vue&type=template&id=52d04418&scoped=true"
import script from "./BookMatch.vue?vue&type=script&lang=js"
export * from "./BookMatch.vue?vue&type=script&lang=js"
import style0 from "./BookMatch.vue?vue&type=style&index=0&id=52d04418&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d04418",
  null
  
)

export default component.exports